
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComputerServer as ObiComputerServerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-computer-server.js';
 
 
 

 
 export const ObiComputerServer = createComponent({
   react: React,
   tagName: 'obi-computer-server',
   elementClass: ObiComputerServerElement,
   events: {
     
   }
  });
 
 